/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import React from 'react';
import { LogoIcon } from './logo-icon';

export const TokenHeaderPlaceholder: React.FC = () => {
    return (
        <div className="w-full h-full bg-gradient-to-br from-stone-800 via-stone-900 to-black flex items-center justify-center relative overflow-hidden">
            {/* Subtle grid pattern */}
            <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(255,255,255,0.05)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.05)_1px,transparent_1px)] bg-[size:20px_20px] opacity-50"></div>
            
            {/* Central branded element */}
            <div className="relative flex flex-col items-center gap-2 opacity-20">
                <LogoIcon className="w-12 h-12" />
                <span className="text-xs font-bold text-stone-600 uppercase tracking-widest">
                    THE FOUNDRY
                </span>
            </div>
        </div>
    );
};